import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Box, Button, Chip, Container, Paper, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import { useNavigate } from 'react-router-dom';

export default function AITranslationPage() {
    const navigate = useNavigate();
    return (
        <Authenticator>
            {({ signOut }) => (
                <Box sx={{ minHeight: '100vh', bgcolor: '#f7f8fa', py: { xs: 3, md: 6 } }}>
                    <Container maxWidth="md">
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                            <Button variant="outlined" onClick={() => navigate('/')}>Back to Herbie Terms</Button>
                            <Button color="inherit" onClick={signOut}>Sign out</Button>
                        </Stack>
                        <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, textAlign: 'center', border: '1px solid', borderColor: 'divider', borderRadius: 3 }}>
                            <TranslateOutlinedIcon sx={{ fontSize: 56, color: 'primary.main', mb: 2 }} />
                            <Typography variant="h4" component="h1" fontWeight={800} gutterBottom>
                                High Quality AI Translation &amp; Terminology Matching
                            </Typography>
                            <Typography color="text.secondary" sx={{ maxWidth: 550, mx: 'auto', mb: 3 }}>
                                AI-powered translation with integrated terminology matching against the Herbieterms database & client voice.
                            </Typography>
                            <Chip icon={<LockOutlinedIcon />} label="Access required" variant="outlined" sx={{ mb: 2 }} />
                            <Typography variant="body1" sx={{ maxWidth: 500, mx: 'auto' }}>
                                This service is currently available by request only. Please contact your administrator to request access.
                            </Typography>
                        </Paper>
                    </Container>
                </Box>
            )}
        </Authenticator>
    );
}
